import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { propTypes } from 'formsy-react';
import withFormsyValidations from '../withFormsyValidations';

class TextareaInput extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      required: PropTypes.bool,
      disableValidations: PropTypes.bool,
      maxLength: PropTypes.number,
      minLength: PropTypes.number,
      disabled: PropTypes.bool,
      rows: PropTypes.number,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      required: false,
      disabled: false,
      rows: 2,
      maxLength: undefined,
      minLength: undefined,
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { name, setValue, onChange } = this.props;
    const { value } = event.currentTarget;
    setValue(value, false);
    onChange(name, value);
  }

  render() {
    // Dont remove onChange from below.
    const {
      value,
      name,
      id,
      errorMessage,
      isValid,
      required,
      disabled,
      rows,
      cols,
      maxLength,
      minLength,
    } = this.props;

    const emptyStringIfNull = value === null ? '' : value;

    return (
      <div>
        <Input
          invalid={!isValid}
          type="textarea"
          id={id}
          rows={rows}
          cols={cols}
          required={required}
          value={emptyStringIfNull}
          disabled={disabled}
          name={name}
          maxLength={maxLength}
          minLength={minLength}
          onChange={this.changeValue}
        />
        <span>{errorMessage}</span>
      </div>
    );
  }
}

export default withFormsyValidations(TextareaInput, props => ({
  noWierdos(values, value) {
    if (props.disableValidations) return true;
    if (!value) return true;

    // eslint-disable-next-line
    return /^[\p{L}\’\\\x{0308}\x{030a}a-zåäöéáœæøüA-ZÅÄÖÉÁÜŒÆØ0-9 –:\.`´’'",;\^¤#%§£$€¢¥©™°&\/\(\)=\+\-\*_\!?²³®½\@\x{00a0}\n\r]+$/.test(
      value,
    );
  },
}));
